import React, { useState } from 'react';
import { Backdrop, Box, Button, CircularProgress, IconButton, Typography } from "@mui/material";
import { ReactComponent as BackArrow } from "../Assets/svg/BackArrow.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../Assets/svg/ArrowRightIconTransparent.svg";

function SelectUserToLogin() {
    const [openBackdrop, setOpenBackdrop] = useState(false);


    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };


    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ position: "relative", width: '100%', height: '100vh' }} className="login-box">
                <Box sx={{ p: "25px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Box></Box>
                        <IconButton>
                            <BackArrow />
                        </IconButton>
                    </Box>
                    <Box className="top-settings-header">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Box className="avatar-container">
                                {/* {userInfo.Avatar && userInfo.Avatar != "" ? <img src={userInfo.Avatar} /> : <img src='./assets/img/User-avatar.svg.png' />} */}
                                <img src='./assets/img/User-avatar.svg.png' />
                            </Box>
                            <Box>
                                <Typography component='p' sx={{ mb: 1, fontSize: '14px' }}>
                                    {/* {userInfo.FullName} */}
                                    املاک عمارت
                                </Typography>
                                <Typography component='p' sx={{ fontSize: '14px' }}>
                                    {/* {userInfo.AgencyMobile} */}
                                    ۰۹۱۵۸۷۹۵۳۴۲
                                </Typography>
                            </Box>
                        </Box>
                        <Box>

                        </Box>
                    </Box>
                    <Box sx={{ mt: 4 }}>
                        <Button className="select-user-item">
                            <Box sx={{ flex: 1,display:"flex",gap:"10px" }}>
                                <img src='/assets/img/prop-example.png' />
                                <Box sx={{display:"flex",flexDirection:"column",justifyContent:"center"}}>
                                    <Box sx={{fontSize:"12px"}}>علی</Box>
                                    <Box sx={{fontSize:"10px"}}>مدیر</Box>
                                </Box>
                            </Box>
                            <Box sx={{pl:3,display:"inline-flex",alignItems:"center"}}>
                                <ArrowRightIconTransparent style={{ stroke: "#fff", transform: "rotate(180deg)" }} />
                            </Box>
                        </Button>
                    </Box>

                </Box>
            </Box>
        </>
    );
}

export default SelectUserToLogin;